const authConfig: any = {
  userPoolId: "ap-southeast-2_5Y4RnIH3f",
  userPoolAppClientId: "3abp0nnh17eop2sbh72f6hrp15",
};

export default authConfig;
